// Pure formatters used by TopPostsList. Kept as a separate module so they
// can be unit-tested without rendering React.

import type { MediaType } from "@community-analytics/shared";

/**
 * Map a Telegram MediaType enum into a single short label. Hidden behind a
 * helper so the §15.3 "no message text" rule is enforced at one site —
 * callers can never accidentally surface caption strings.
 */
export function mediaLabel(media: MediaType | null): string {
  switch (media) {
    case "PHOTO":
      return "Photo";
    case "VIDEO":
      return "Video";
    case "AUDIO":
      return "Audio";
    case "VOICE":
      return "Voice";
    case "STICKER":
      return "Sticker";
    case "ANIMATION":
      return "GIF";
    case "DOCUMENT":
      return "File";
    case "OTHER":
      return "Other";
    case null:
      return "Text";
  }
}

/**
 * Map a content length (chars) into a coarse human bucket. The §15.3
 * "metadata only" rule means we never show the actual text — the bucket is
 * the closest the UI gets to "what kind of post is this."
 */
export function lengthBucket(chars: number): string {
  if (chars <= 0) return "Empty";
  if (chars < 50) return "Short";
  if (chars < 280) return "Medium";
  if (chars < 1000) return "Long";
  return "Very long";
}
